import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {Card, Col, Layout, Row} from 'antd';
import {Spinner} from './components/UIToolbox';

const { Content } = Layout;

class ActionnableCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderCardFooter = (label, action, brand) => (
    <Row type="flex" onClick={action} gutter={16} >
      <div
        className="hoverable"
        style={{
          width: '100%',
          paddingLeft: 24,
          paddingRight: 20,
          paddingTop: 10,
          borderTop: '1px solid rgb(230, 230, 230)',
        }}
      >
        <Col span={12}>
          <p style={{ float: 'left', fontWeight: 'bold', fontSize: 16 }}>{label}</p>
        </Col>
        <Col span={12} >
          <svg className={`bmw-icon icon-${brand}`} style={{ float: 'right' }} >
            <use xlinkHref="#icon-arrow-right"/>
          </svg>
        </Col>
      </div>
    </Row>
  );

  render() {
    const {
      intl: { formatMessage },
      footerLabel,
      img,
      imgAlt,
      fields,
      alternativeText,
      action,
      displayedObject,
      loading,
      displayFooter,
      title,
      children,
      brand='bmw',
      contentCheck,
      fallbackMessage
    } = this.props;
    if(!contentCheck){
      return (
        <Card
          bodyStyle={{ padding: 0 }}
          style={{ paddingBottom: 0, overflow: 'hidden' }}
          title={title && <h3 style={{ float: 'left', fontWeight: 'bold', fontSize: 16 }}>{title}</h3>}
          bordered
        >
          <Row
            type="flex"
            style={{ padding: 10, height: '200px', textAlign: 'center' }}
            gutter={16}
          >
            <Col span={8} style={{ margin: 'auto' }}>
              <p>{fallbackMessage}</p>
            </Col>
          </Row>
        </Card>
      );
    }
    if (loading) {
      return (
        <Card
          bodyStyle={{ padding: 0 }}
          style={{ paddingBottom: 0, width: '100%', height: '100%' }}
          title={title && <h3 style={{ float: 'left', fontWeight: 'bold', fontSize: 16 }}>{title}</h3>}
          bordered
        >
          <Row
            type="flex"
            style={{ padding: 10, height: '200px', textAlign: 'center' }}
            gutter={16}
          >
            <Col span={24} style={{ margin: 'auto' }}>
              <Spinner />
            </Col>
          </Row>
        </Card>
      );
    }
    if (!displayedObject) {
      return (
        <Card
          bodyStyle={{ padding: 0 }}
          style={{ paddingBottom: 0, overflow: 'hidden' }}
          title={title && <h3 style={{ float: 'left', fontWeight: 'bold', fontSize: 16 }}>{title}</h3>}
          bordered
        >
          <Row
            type="flex"
            style={{ padding: 10, height: '200px', textAlign: 'center' }}
            gutter={16}
          >
            <Col span={8} style={{ margin: 'auto' }}>
              <p>{alternativeText}</p>
            </Col>
          </Row>
          {this.renderCardFooter(footerLabel, action, brand)}
        </Card>
      );
    }
    return (
      <Card
        bodyStyle={{ padding: 0 }}
        style={{ paddingBottom: 0, overflow: 'hidden' }}
        title={title && <h3 style={{ float: 'left', fontWeight: 'bold', fontSize: 16 }}>{title}</h3>}
        bordered
      >
        <div style={{paddingLeft: 24}}>
          <Row type="flex" style={{ height: children ? '100px' : '200 px' }} gutter={16}>
            {img && (
              <Col span={12} style={{ margin: 'auto', textAlign:'center' }}>
                <img style={{ objectFit:'fill',maxHeight: '200px', margin: 'auto' }} src={img} alt={imgAlt} />
              </Col>
            )}
            <Col span={img ? 12 : 24} style={{ margin: 'auto', padding: 20 }}>
              {fields &&
              fields.map((field, index) => (
                <Row key={field.name || index} style={{ fontWeight: field.bold ? 'bold' : '' }}>
                  {field.name ? `${field.name}:` : ''} {field.value}
                </Row>
              ))}
            </Col>
          </Row>
          {children}
        </div>
        {displayFooter && this.renderCardFooter(footerLabel, action, brand)}
      </Card>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  openChangeCarModal: () => dispatch({ type: 'CHANGE_CAR_MODAL', changeCarModal: true }),
});

const mapStateToProps = state => ({
  selectedVehicle: state.customerVehicle.selectedVehicle,
  brand: state.publicContext && state.publicContext.brand,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActionnableCard)
);



// WEBPACK FOOTER //
// ./src/public/ActionnableCard.js